/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Agenda_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove from my agenda" |
*
* @param {Tournaments_Agenda_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_agenda_remove = /** @type {((inputs?: Tournaments_Agenda_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Agenda_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer de mon agenda")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar de mi agenda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover da minha agenda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi dalla mia agenda")
	return /** @type {LocalizedString} */ ("Remove from my agenda")
});